import React from "react";
import { Redirect, Route } from "react-router-dom";
import useAuth from "../hooks/useAuth";

export interface IProps {
	exact?: boolean;
	path: string;
	component?: React.ComponentType<any>;
	restricted?: boolean;
	children?: React.ReactNode;
}

const PublicRoute: React.FC<IProps> = ({ children, restricted, ...rest }) => {
	const { isLoggedIn, isLoading } = useAuth();

	return (
		<Route
			{...rest}
			render={() => (!isLoading && isLoggedIn && restricted ? <Redirect to="/dashboard" /> : children)}
		/>
	);
};

export default PublicRoute;
